import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  sender_name: '送金者名',
  sender_wallet: '送金者ウォレット',
  last_n_digits: '取引リファレンス',
  invoice_flow__multi_time_remainin: '残り時間',
  invoice_flow__multi_or: 'または',
  invoice_flow__multi_open_app: 'アプリで開く',
  invoice_flow__multi_return_button: 'ウェブサイトに戻る',
  invoice_flow__card_transfer_button: '確認',
  invoice_flow__multi_upi_qr_step_1: '上記のQRコードをスキャンまたはコピーしてください',
  invoice_flow__multi_upi_qr_step_2: 'お支払いください',
  invoice_flow__multi_step_3: '<b>{attributes}</b> を入力し、「確認」を押してください',
  invoice_flow__multi_upi_qr_mob_step_1:
    '上記のQRコードをスキャンするか、「アプリで開く」を押してください',
  invoice_flow__multi_bank_transfer_step_1: '振込情報をコピー',
  invoice_flow__multi_bank_transfer_step_2: 'お支払いください',
  invoice_flow__card_transfer_step_1: '振込情報をコピー',
  invoice_flow__card_transfer_step_2:
    '指定金額を振り込んでください（銀行口座、最寄りの銀行、またはセルフサービス端末をご利用ください）',
  invoice_flow__card_transfer_step_3: '確認情報を入力: <b>{attributes}</b>',
  invoice_flow__card_transfer_step_4: '振込完了後、<b>「確認」</b> を押してください',
};
